export default (theme) => ({
    root: {},
    intro: {
        display: 'flex',
        marginBottom: 32,
    },
    introIcon: {
        width: 40,
        height: 40,
        flexShrink: 0,
        marginRight: 16,
    },
    introText: {},
    cancel: {
        marginRight: 8,
    },
    codeContainer: {
        width: 320,
        margin: '0 auto',
    },
    advice: {
        marginBottom: 16,
    },
    resendContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginBottom: 32,
    },
    codeInputs: {
        textAlign: 'center',
    },
    wait: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: 16,
        marginBottom: 32,
    },
    waitIcon: {
        marginBottom: 16,
    },
    waitTextContainer: {
        textAlign: 'center',
    },
    waitText: {
        display: 'inline',
    },
});
